define('view/module/MessageView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Message view
     *
     * @class MessageView
     */
    return LayoutView.extend({

        template: '#message_view',


        initialize: function () {
            var _this = this;
            LayoutView.prototype.initialize.apply(this);


            if (this.getOption('autoHideTimeout')) {
                setTimeout(function () {
                    _this.remove();
                    _this.unbind();
                }, this.getOption('autoHideTimeout'));
            }
        },

        serializeData: function () {
            var res = LayoutView.prototype.serializeData.apply(this);

            res.message = this.getOption('message');
            res.type = this.getOption('type');

            return res;
        },

        onDomRefresh: function () {
            if (this.getOption('triggerEventOnShown')) {
                Backbone.Wreqr.radio.vent.trigger('status_message', 'shown');
            }
        }

    });

});
